var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-wrapper"},[_c('button',{staticClass:"social-login-btn",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),_c('span',{staticClass:"btn-text"},[_vm._v(_vm._s(_vm.btnText))])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }